import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Sparkles, UserCheck, AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ReferralLandingPage = () => {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true, valid: false, inviter: null, error: '' });

  useEffect(() => {
    const validate = async () => {
      try {
        // Track click (fire-and-forget)
        axios.post(`${API_URL}/api/viral/track-click/${code}`).catch(() => {});
        const res = await axios.get(`${API_URL}/api/viral/validate/${code}`);
        setState({ loading: false, valid: true, inviter: res.data, error: '' });
      } catch (e) {
        setState({ loading: false, valid: false, inviter: null, error: e.response?.data?.detail || 'Invalid referral code' });
      }
    };
    validate();
  }, [code]);

  if (state.loading) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center" data-testid="referral-landing-loading">
        <Loader2 className="h-8 w-8 text-[#E07A3A] animate-spin" />
      </div>
    );
  }

  if (!state.valid) {
    return (
      <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-6" data-testid="referral-landing-invalid">
        <div className="max-w-md text-center">
          <AlertTriangle className="h-12 w-12 text-[#E07A3A] mx-auto mb-4" />
          <h1 className="font-['Playfair_Display'] text-3xl text-white mb-3">Invalid Referral Link</h1>
          <p className="text-white/50 text-sm mb-6">{state.error}. You can still join Shopperden without a referral code.</p>
          <a href="/register" className="inline-block bg-[#E07A3A] text-white px-8 py-3 tracking-widest uppercase font-bold">
            Continue to Sign Up
          </a>
        </div>
      </div>
    );
  }

  // Redirect to register with ref query param
  return <Navigate to={`/register?ref=${encodeURIComponent(code)}&inviter=${encodeURIComponent(state.inviter.inviter_first_name)}`} replace />;
};

export default ReferralLandingPage;
